export enum FilterMutations {
  RESET = "RESET",
  REMOVE = "REMOVE",
  SET = "SET",
  APPLY = "APPLY",
}
